import { useEffect, useRef, useState } from "react";

// For a row the global search opened: scrolls it into view and highlights it
// for a moment. `focus` is a new object ({ id, at }) each time it is picked,
// so picking the same row again works too.
export const useFocusFlash = (focus) => {
  const ref = useRef(null);
  const [highlighted, setHighlighted] = useState(false);
  useEffect(() => {
    if (!focus) return undefined;
    setHighlighted(true);
    ref.current?.scrollIntoView?.({ behavior: "smooth", block: "center" });
    const timer = setTimeout(() => setHighlighted(false), 2000);
    return () => clearTimeout(timer);
  }, [focus]);
  return { ref, highlighted };
};
